export type TextTone = 'default' | 'secondary' | 'tertiary' | 'inverse' | 'error';

const TONE_CLASSES: Record<TextTone, string> = {
  default: 'text-fg',
  secondary: 'text-fg-muted',
  tertiary: 'text-fg-subtle',
  inverse: 'text-fg-inverse',
  error: 'text-danger',
};

export const getToneClass = (tone: TextTone, muted = false): string =>
  muted ? `${TONE_CLASSES[tone]}/70` : TONE_CLASSES[tone];
